import { PrivateEquityCapitalCall } from "types/PrivateEquityCapitalCall";
import { ActionType, getType } from "typesafe-actions";
import * as privateEquityCapitalCallActions from "./privateEquityCapitalCallActions";

export type PrivateEquityCapitalCallState = {
  [K in privateEquityCapitalCallActions.PrivateEquityCapitalCallContentType]?: {
    loading?: boolean;
    data?: PrivateEquityCapitalCall[];
    error?: string;
  };
};

export type PrivateEquityCapitalCallActions = ActionType<typeof privateEquityCapitalCallActions>;

export default function privateEquityCapitalCall(state: PrivateEquityCapitalCallState = {},
                                                 action: PrivateEquityCapitalCallActions) {
  switch (action.type) {
    case getType(privateEquityCapitalCallActions.load):
      return { ...state, [action.contentType]: { ...state[action.contentType], loading: true } };
    case getType(privateEquityCapitalCallActions.loadSuccess):
      return {
        ...state,
        [action.contentType]: { loading: false, data: action.data, error: undefined },
      };
    case getType(privateEquityCapitalCallActions.loadFail):
      return { ...state, [action.contentType]: { loading: false, error: action.error } };
    default:
      return state;
  }
}
